<div class="card px-3 py-1" style="z-index: 0">
    <div>
        <div class="d-flex flex-column">
            <span class="bold text-dark">{{ 'HISTORY.AUTO_ORDER.TITLE' | translate }}</span>
            <span class="small text-dark">
                {{ 'HISTORY.AUTO_ORDER.SUBTITLE' | translate }}
                <span class="bold">{{ benefitName }}</span>
            </span>
            <hr class="w-100"/>
            <div class="form-group mb-0">
                <ng-select [(ngModel)]="autoOrderState"
                           [items]="stateOptions"
                           bindValue="value"
                           [searchable]="false"
                           [clearable]="false"
                           id="autoOrderStateSelect"
                           [attr.aria-label]="'autoOrderStateSelect'"
                           appNgSelectAriaControl>
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.label | translate }}
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                        {{ item.label | translate }}
                    </ng-template>
                </ng-select>
            </div>
            <div class="d-flex flex-column" *ngIf="autoOrderState === AutoOrderState.Active">
                <div class="d-flex align-items-center justify-content-between mt-1">
                    <span style="max-width: 150px">{{ 'HISTORY.AUTO_ORDER.MAX_NR_ORDER' | translate }}</span>
                    <div class="custom-control custom-control-primary custom-switch justify-content-end">
                        <input type="checkbox" [(ngModel)]="hasDynamicQuantity" class="custom-control-input"
                               id="hasDynamicQuantitySwitch" aria-label="toggleState"/>
                        <label class="custom-control-label pl-3" id="hasDynamicQuantitySwitchLabel"
                               for="hasDynamicQuantitySwitch"></label>
                    </div>
                </div>
                <span class="mt-1 bold text-dark"
                      *ngIf="hasDynamicQuantity">{{ 'HISTORY.AUTO_ORDER.DYNAMIC_QUANTITY_INFO' | translate }}</span>
                <div class="mt-1 d-flex align-items-center justify-content-between"
                     *ngIf="!hasDynamicQuantity">
                    <label class="fs-14 text-body" style="max-width: 150px"
                           id="ticketSelectorLabel">{{ 'HISTORY.AUTO_ORDER.STRICT_NR_ORDER' | translate }}</label>
                    <app-meal-ticket-selector
                            [maxNumberOfUnits]="maxNumberOfUnits"
                            [mealTicketsOptions]="mealTicketsOptions"
                            [(selectedQuantity)]="selectedQuantity"
                            [clearable]="false"
                            [placeHolder]="''"
                            [fixWidth]="55"
                            ariaLabel="ticketSelectorLabel"
                    ></app-meal-ticket-selector>
                </div>
            </div>
            <span *ngIf="autoOrder !== null && !autoOrder.isActive && autoOrderState === AutoOrderState.Active"
                  class="text-danger mt-1">
                {{ 'HISTORY.AUTO_ORDER.STATUS_CHANGE_INACTIVE_TO_ACTIVE' | translate }}
            </span>
            <span *ngIf="autoOrder !== null && autoOrder.isActive && autoOrderState === AutoOrderState.Inactive"
                  class="text-danger mt-1">
                {{ 'HISTORY.AUTO_ORDER.STATUS_CHANGE_ACTIVE_TO_INACTIVE' | translate }}
            </span>
            <span class="d-block mt-1"
                  [ngbTooltip]="isRestrictedByOrderStatus ? ('HISTORY.AUTO_ORDER.DISABLED_TOOLTIP' | translate) : ''"
                  placement="auto">
                <button class="btn btn-primary w-100"
                        [disabled]="!hasChanges() || isRestrictedByOrderStatus"
                        (click)="saveOptions()">
                    {{ 'HISTORY.AUTO_ORDER.SAVE_BUTTON' | translate }}
                </button>
            </span>
            <hr class="w-100"/>
            <span *ngIf="autoOrderState === AutoOrderState.Active; else inactiveMessage;"
                  [innerHTML]="'HISTORY.AUTO_ORDER.ACTIVE_INFO' | translate"></span>
            <ng-template #inactiveMessage>
                <span *ngIf="autoOrder == null && autoOrderState === AutoOrderState.Inactive; else inactiveForAlreadyActiveMessage;"
                      [innerHTML]="'HISTORY.AUTO_ORDER.INACTIVE_INFO' | translate"></span>
            </ng-template>
            <ng-template #inactiveForAlreadyActiveMessage>
                <span *ngIf="autoOrder != null && autoOrderState === AutoOrderState.Inactive;"
                      [innerHTML]="'HISTORY.AUTO_ORDER.INACTIVE_INFO_ACTIVE' | translate"></span>
            </ng-template>
        </div>
    </div>
</div>
